'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import UIButtonWrapper from '../layout/UIButtonWrapper';
var ALIGNMENT_OPTIONS = {
  between: 'between',
  left: 'start',
  center: 'center',
  right: 'end'
};
export default function UIDialogFooter(_ref) {
  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["align", "children", "className"]);

  return React.createElement("footer", Object.assign({}, rest, {
    className: classNames("private-modal__footer uiDialogFooter", className)
  }), React.createElement(UIButtonWrapper, {
    justify: ALIGNMENT_OPTIONS[align]
  }, children));
}
UIDialogFooter.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right', 'between']).isRequired,
  children: PropTypes.node
};
UIDialogFooter.defaultProps = {
  align: 'left'
};
UIDialogFooter.displayName = 'UIDialogFooter';